import { X } from "lucide-react";

const MEET_OPTIONS = [
  { label: "Llamada de 5 min", value: "call5" },
  { label: "Meet de 5 min", value: "meet5" },
  { label: "Meet de 30 min", value: "meet30" },
  { label: "Meet de 1 hora", value: "meet60" },
];

// 02.7-settings.md §5/paso b -- extraído de WhatsPanel.jsx (popup de "agendar reunión" disparado
// por el tag semántico "Meet"). Puramente presentacional: la búsqueda de miembros (ahora
// `spacesApi.fetchMembers`, ver el container) y la construcción del link viven fuera.
export default function WhatsMeetPopup({ searchQuery, onSearchChange, members, selectedUser, onSelectUser, onClose, onPickOption }) {
  return (
    <div style={{
      margin: "0 var(--space-4) var(--space-3)",
      padding: "var(--space-3)",
      backgroundColor: "#fff",
      border: "1px solid #e0e0e0",
      borderRadius: "var(--radius-lg)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      display: "flex",
      flexDirection: "column",
      gap: "var(--space-3)"
    }}>
      <div style={{ fontWeight: 600, fontSize: "14px", color: "#333", display: "flex", justifyContent: "space-between" }}>
        <span>Seleccionar Calendario</span>
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><X size={16} color="#888" /></button>
      </div>

      <input
        type="text"
        placeholder="Buscar colaborador..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        style={{ padding: "var(--space-2)", borderRadius: "var(--radius-md)", border: "1px solid #ddd", fontSize: "13px" }}
      />

      <div style={{ display: "flex", overflowX: "auto", gap: "var(--space-2)", paddingBottom: "var(--space-1)" }}>
        {members
          .filter(m => (m.name || m.nick || '').toLowerCase().includes(searchQuery.toLowerCase()))
          .map(m => (
            <div
              key={m.id}
              onClick={() => onSelectUser(m)}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "var(--space-1)",
                cursor: "pointer",
                opacity: selectedUser?.id === m.id ? 1 : 0.6,
                border: selectedUser?.id === m.id ? "2px solid #3b82f6" : "2px solid transparent",
                padding: "var(--space-1)",
                borderRadius: "var(--radius-md)",
                minWidth: "60px"
              }}
            >
              {m.image ? (
                <img src={m.image} alt={m.name || m.nick} style={{ width: "36px", height: "36px", borderRadius: "50%", objectFit: "cover" }} />
              ) : (
                <div style={{ width: "36px", height: "36px", borderRadius: "50%", backgroundColor: "#e2e8f0", display: "flex", alignItems: "center", justifyContent: "center", color: "#475569", fontWeight: "bold" }}>
                  {(m.name || m.nick || '?').charAt(0).toUpperCase()}
                </div>
              )}
              <span style={{ fontSize: "11px", textAlign: "center", maxWidth: "60px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{m.name || m.nick}</span>
            </div>
          ))}
      </div>

      {selectedUser && (
        <div style={{ display: "flex", gap: "var(--space-2)", flexWrap: "wrap", marginTop: "var(--space-1)" }}>
          {MEET_OPTIONS.map(opt => (
            <button
              key={opt.value}
              onClick={() => {
                const durationMatch = opt.value.match(/\d+/);
                const duration = durationMatch ? parseInt(durationMatch[0], 10) : 30;
                onPickOption(duration, selectedUser, opt.value);
              }}
              style={{
                padding: "6px 10px",
                borderRadius: "var(--radius-xl)",
                border: "1px solid #3b82f6",
                backgroundColor: "#e0f2fe",
                color: "#1d4ed8",
                fontSize: "12px",
                fontWeight: "500",
                cursor: "pointer",
                transition: "all 0.2s"
              }}
              onMouseEnter={(e) => { e.target.style.backgroundColor = '#bfdbfe'; }}
              onMouseLeave={(e) => { e.target.style.backgroundColor = '#e0f2fe'; }}
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
